import config from '../../../config';
import LiveRelationshipService from './LiveRelationshipService';
import FakeRelationshipService from './FakeRelationshipService';

const relationshipService = config.offline ? new FakeRelationshipService() : new LiveRelationshipService();

export default relationshipService;
